/**
 * Fileupload Helper class
 */
export default class FileUpload {
    /**
     * File input - List files to upload & escape if wrong file format
     * @param {*} inputFieldId
     */
    fileInputOnChange = (inputFieldId) => {
        const self = this;
        document.getElementById(inputFieldId).addEventListener('change', function (e) {
            if (e.target.files && e.target.files[0]) {
                const findContainer = this.closest('div').querySelector('ul');
                const fileNameContainer = findContainer.getAttribute('id');
                findContainer.innerHTML = '';

                if (!this.classList.contains('valid')) {
                    e.target.files = null;
                    return;
                }

                for (let int = 0; int < e.target.files.length; int++) {
                    const createListElement = document.createElement('li');
                    const listelement = document
                        .getElementById(fileNameContainer)
                        .appendChild(createListElement);
                    const fileSize = self.returnFileSize(e.target.files[int].size);
                    listelement.innerHTML = `<span>${e.target.files[int].name} (${fileSize})</span>`;
                }
            }
        });
    };

    /**
     * FileSize
     * @param number
     * @returns {string}
     */
    returnFileSize = (number) => {
        if (number < 1024) {
            return number + ' bytes';
        } else if (number >= 1024 && number < 1048576) {
            return (number / 1024).toFixed(1) + ' KB';
        } else if (number >= 1048576) {
            return (number / 1048576).toFixed(1) + ' MB';
        }
    };

    /**
     *  Get document meta data etc.
     * @param {*} fileList
     * @returns
     */
    getDocumentList = async (fileList) => {
        const getDocument = (file) => {
            const reader = new FileReader();
            return new Promise((resolve) => {
                reader.onload = (ev) => {
                    const fileContent = ev.target.result.split(',')[1];
                    const fileDoc = {
                        documentName: file.name.replace('.pdf', ''),
                        documentType: file.type.replace('application/', ''),
                        document: fileContent,
                    };
                    resolve(fileDoc);
                };
                reader.readAsDataURL(file);
            });
        };

        const promises = [];
        for (let fileListInt = 0; fileListInt < fileList.length; fileListInt++) {
            promises.push(getDocument(fileList[fileListInt]));
        }

        return await Promise.all(promises);
    };
}
